// User Service - API calls for user management
const API_BASE_URL = 'https://apisaleeasy.psisat.com/api/admin-saleeasy';

export const userService = {
  // Change user password
  async changePassword(username, oldPassword, newPassword) {
    try {
      const response = await fetch(`${API_BASE_URL}/change-password`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          username: username,
          old_password: oldPassword,
          new_password: newPassword
        })
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.result_desc || `HTTP error! status: ${response.status}`);
      }

      if (data.status && data.result_code === "000") {
        return {
          success: true,
          message: data.result_desc || 'Password changed successfully'
        };
      } else {
        throw new Error(data.result_desc || 'Failed to change password');
      }
    } catch (error) {
      console.error('Error changing password:', error);
      return {
        success: false,
        error: error.message
      };
    }
  }
};

export default userService;